(function (angular) {
	angular.module('bizPartEngage').service('modules.missions.service', missionsService);

    missionsService.$inject = ["$http"];

    function missionsService($http) {
    	this.GetMissionsForUser = function () {
    		return $http.get(siteRootPath + 'Api/MissionsUser/GetMissionsForUser');
    	};

    	this.GetMission = function (id) {
    		return $http.get(siteRootPath + 'Api/MissionsUser/GetMission?' + $.param({id: id}));
    	};

    	this.GetUsers = function (id) {
    		return $http.get(siteRootPath + 'Api/MissionsUser/GetUsersWhoHaveCompletedMission', {
				params: {
					missionId: id
				}
    		});
    	};
    }
})(window.angular);
